export const header = 'Λίστα Χειρουργείων Προς Ιδιωτική Δομή';
